import PropTypes from 'prop-types';
import React from 'react';
import Loader from './loader.jsx';
import { httpGET, json } from '../actions/utils';

function fetchLaunchParams(url) {
    return httpGET(url).then(json);
}

export default class EmbedLTI extends React.Component {
    static displayName = 'EmbedLTI';

    static propTypes = {
        content: PropTypes.any,
    };

    iframe = React.createRef();
    form = React.createRef();
    contentWrapper = React.createRef();

    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.onResize = this.onResize.bind(this);
    }

    componentDidMount() {
        const { content } = this.props;

        const { launchParams } = this.state;

        if (!launchParams) {
            fetchLaunchParams(content.launch_params).then(launchParams => {
                this.setState({ launchParams }); // eslint-disable-line react/no-did-mount-set-state
            });
        }

        window.addEventListener('resize', this.onResize);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.launchParams && this.state.launchParams) {
            this.form.current.submit();
        }
        this.onResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize() {
        const iframe = this.iframe.current;
        const parent = this.contentWrapper.current;

        if (!(iframe && parent)) return;

        // The parent will never shrink smaller than the iframe, so it has
        // to be reset to 0 each time to allow the parent to shrink and
        // recalculate.
        iframe.style.cssText = `
            width: 0;
            height: 0;
        `;

        iframe.style.cssText = `
            width: ${parent.offsetWidth};
            height: ${parent.offsetHeight -
                document.querySelector('.navbar').offsetHeight};
        `;
    }

    renderInputs(launchParams) {
        return Object.keys(launchParams).map(key => {
            return (
                <input
                    key={key}
                    type="hidden"
                    name={key}
                    value={launchParams[key]}
                />
            );
        });
    }

    render() {
        const { id } = this.props.content;
        const { launchParams } = this.state;
        if (!launchParams) {
            return <Loader message="Fetching launch params" />;
        }

        const { launch_url, ...lp } = launchParams;
        const key = 'iframe-' + id;

        return (
            <div>
                <div className="embedded-content-container lti-content">
                    <div
                        className="embedded-content-wrapper"
                        ref={this.contentWrapper}
                    >
                        <iframe
                            name={key}
                            id={key}
                            title="Embedded LTI"
                            allow="clipboard-write"
                            ref={this.iframe}
                        />
                        <form
                            ref={this.form}
                            target={key}
                            action={launch_url}
                            method="POST"
                            encType="application/x-www-form-urlencoded"
                        >
                            {this.renderInputs(lp)}
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/embed_lti.jsx